'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Channels from '../base/channels'
import Fx from '../fx/Effects'
import FlowWaypoints from '../fx/FlowWaypoints'



let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--about'
        // Launch Fn
        Env.framework.UI.disableHashLinks()
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        Env.framework.UI.allowHashLinks()
        this.waypoints.destroy()
        this.fx.destroy()
        Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    finalize()
    {
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
        }, 100);
        setTimeout(() => {
            this.pointToAnchor()
            this.waypoints = new FlowWaypoints(this.view)
        }, 200);
        setTimeout(() => {
            this.fx = new Fx(this.view)
        }, 500);
    }

    intro()
    {
        const tl = new TimelineLite()
        const $bg = this.view.querySelector('.jsBg')
        const $title = this.view.querySelector('.jsFxTitle')
        const $desc1 = this.view.querySelector('.jsFxDesc')

        tl.add([
            TweenLite.fromTo($title , .8 , { opacity : 0 , y : 10 } , { opacity : 1 , y : 0 , ease : Power3.easeOut }),
            TweenLite.fromTo($desc1 , .8 , { opacity : 0 , y : 20 } , { opacity : 1 , y : 0 , ease : Power3.easeOut , delay : .1 }),
            TweenLite.fromTo($bg , .8 , { opacity : 0 , y : 20 } , { opacity : 1 , y : 0 , ease : Power3.easeOut , delay : .2 }),
        ])
    }

    pointToAnchor()
    {
        let hash = window.location.hash
        if(hash.length) {
            hash = hash.split('#')[1]
            const query = `a[name='${hash}']`
            const $element = this.view.querySelector(query)
            const coords = $element.getBoundingClientRect()
            window.scrollTo(0,coords.top)
        }
    }
}

page = Barba.BaseView.extend({
    namespace: 'about',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;